import { Clause, InnerClause } from "./model";
import { transformToCustomFieldClause } from "./transformer";

export function createClauseFromInnerClause(
  clause: InnerClause,
  custom?: boolean
): Clause {
  return {
    and: [custom ? transformToCustomFieldClause(clause) : clause],
  };
}
